import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'

const useStyles = makeStyles((theme: Theme) => ({
  loginShell: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'stretch',
    backgroundColor: theme.palette.mode === 'dark' ? '#000000' : '#FBFBFD',
    fontFamily:
      '"Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
  },
  loginVisual: {
    flex: 1.05,
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: theme.palette.mode === 'dark' ? '#000000' : '#FBFBFD',
    color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#0A0F1C',
    padding: theme.spacing(7),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4)
    }
  },
  loginVisualImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    zIndex: 0,
    mixBlendMode:
      theme.palette.mode === 'dark' ? 'screen' : ('normal' as const),
    opacity: theme.palette.mode === 'dark' ? 0.9 : 1
  },
  loginVisualOverlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 0,
    background:
      theme.palette.mode === 'dark'
        ? 'linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 35%, rgba(0,0,0,0.55) 100%)'
        : 'linear-gradient(180deg, rgba(251,251,253,0.55) 0%, rgba(251,251,253,0.05) 35%, rgba(251,251,253,0.55) 100%)',
    pointerEvents: 'none'
  },
  loginVisualBrand: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    fontWeight: 700,
    fontSize: '0.85rem',
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    color: theme.palette.mode === 'dark' ? '#FFFFFFCC' : '#0A0F1CB3'
  },
  loginVisualCopy: {
    position: 'relative',
    maxWidth: 440
  },
  loginVisualHeadline: {
    fontSize: '2.5rem',
    fontWeight: 900,
    lineHeight: 1.1,
    letterSpacing: '-0.02em',
    [theme.breakpoints.down('lg')]: {
      fontSize: '2rem'
    }
  },
  loginVisualTagline: {
    marginTop: theme.spacing(2),
    fontSize: '1.0625rem',
    lineHeight: 1.5,
    color: theme.palette.mode === 'dark' ? '#FFFFFF99' : '#0A0F1C99'
  },
  loginVisualFootnote: {
    position: 'relative',
    fontSize: '0.75rem',
    letterSpacing: '0.04em',
    color: theme.palette.mode === 'dark' ? '#98989D' : '#6E6E73'
  },
  loginPanel: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(5),
    backgroundColor: theme.palette.mode === 'dark' ? '#000000' : '#FFFFFF',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2.5)
    }
  },
  loginCard: {
    width: '100%',
    maxWidth: 380,
    display: 'flex',
    flexDirection: 'column'
  },
  loginLogoRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(5)
  },
  loginTitle: {
    fontSize: '1.875rem',
    fontWeight: 900,
    letterSpacing: '-0.015em',
    lineHeight: 1.2,
    color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#0A0F1C'
  },
  loginSubtitle: {
    marginTop: theme.spacing(1),
    fontSize: '0.9375rem',
    lineHeight: 1.45,
    color: theme.palette.mode === 'dark' ? '#FFFFFF99' : '#6E6E73',
    marginBottom: theme.spacing(4)
  },
  loginFooter: {
    marginTop: theme.spacing(5),
    fontSize: '0.75rem',
    letterSpacing: '0.01em',
    color: theme.palette.mode === 'dark' ? '#98989D' : '#6E6E73',
    textAlign: 'center'
  }
}))

export default useStyles
